const config = {
    backEnd: process.env.REACT_APP_BACKEND || 'http://localhost:5000',
    mainProject: "Míny - "
}

export default config;
